module.exports = __webpack_public_path__ + "static/media/telegramPreview.4c817452.png";